import { render, staticRenderFns } from "./MessageSendWithAttachmentView.vue?vue&type=template&id=a52e30a4&scoped=true&"
import script from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
export * from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendWithAttachmentView.vue?vue&type=style&index=0&id=a52e30a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52e30a4",
  null
  
)

export default component.exports